import { ScoreType } from '../../../../../store/admin/eventFormats/store';
import { IMetaFormat } from '../../../../../store/admin/roundFormats/store';

import { ISkinsResults } from '../../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';

type TGetRowResult = (
  skinsResults: ISkinsResults,
  hole: string,
  selectedScoreType?: ScoreType | undefined,
  selectedRoundFormat?: IMetaFormat | undefined
) => number | undefined;

export const getSkinsRowResult: TGetRowResult = (
  skinsResults,
  hole,
  selectedScoreType,
  selectedRoundFormat
) => {
  if (selectedScoreType) {
    const formattedScoreType = ScoreType[selectedScoreType].toLowerCase();

    const field =
      formattedScoreType === 'net' && selectedRoundFormat && selectedRoundFormat.adjustedHandicap
        ? 'adjustedNet'
        : (formattedScoreType as 'gross' | 'net');

    return skinsResults[Number(hole)][0][field];
  }
};
